
function insertParam(key, value)
{
 
  
    key = encodeURI(key); value = encodeURI(value);

    var kvp = document.location.search.substr(1).split('&');

    var i=kvp.length; var x; while(i--) 
    {
        x = kvp[i].split('=');

        if (x[0]==key)
        {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
        }
    }

    if(i<0) {kvp[kvp.length] = [key,value].join('=');}

    //this will reload the page, it's likely better to store this until finished
    var url = kvp.join('&'); 
  	url = url.replace('&','');
  	var newurl = window.location.href.split('?')[0] + '?' + url;

	window.history.replaceState(null, null, newurl);
}

//<![CDATA[

$(function() {
  // IMPORTANT: Fill in your client key
  var clientKey = "js-CZ0udffBfTMhGs64RGyBQ4Edj0agJClWRiasqfG36qD8MXsoXwdjgY34VHI35pgu";
  var retailerZips = "";
  var cache = {};
  
  $("#retailer-search").bind("input", function() {
      var value = $(this).val().toLowerCase();
      $('.retailer-logo').show(); 	
      if(value.length != 5){ 
        $(".logo-bar__item").filter(function() {
          var search = $(this).data('zip').toString();
          $(this).toggle(search.toLowerCase().indexOf(value) > -1)
        });
      }else{
        getMatchCode(value);
      }
    });
  
  function buildRetailerZips(){
    $('.retailer-us').each(function(){
      if (typeof $(this).data('zip') !== 'undefined') {
        retailerZips += "," + $(this).data('zip') ;
      }
    });
  }
  function getMatchCode(zipcode1){
    if (zipcode1.length == 5 && /^[0-9]+$/.test(zipcode1) )
    {


        // Check cache
        var cacheKey = zipcode1;
        if (cacheKey in cache)
        {
            handleResp(cache[cacheKey], zipcode1);
        }
        else
        {
          	var zip_string = zipcode1 + retailerZips;
          	var radius = 415;
            // Build url
            var url = "https://www.zipcodeapi.com/rest/"+clientKey+"/match-close.json/"+ zip_string +"/"+ radius +"/km";

            // Make AJAX request
            $.ajax({
                "url": url,
                "dataType": "json",
              	"type": "GET"
            }).done(function(data) {
                handleResp(data, zipcode1);

                // Store in cache
                cache[cacheKey] = data;
            }).fail(function(data) {
                if (data.responseText && (json = $.parseJSON(data.responseText)))
                {
                    // Store in cache
                    cache[cacheKey] = json;

                    // Check for error
                    if (json.error_msg)
                        console.log(json.error_msg);
                }
                else
                    console.log('Request failed.');
            });
        }
    }
  }
  

  /** Handle successful response */
  function handleResp(data, zipcode)
  {
      // Check for error
    if (data.error_msg){
      console.log(data.error_msg);
    }else {

      $('.retailer-logo').hide();
      $.each(data, function() {
        var zipcode1 = this["zip_code1"];
      	var zipcode2 = this["zip_code2"];
        if(zipcode1 == zipcode || zipcode2 == zipcode){
          if(zipcode1 == zipcode){
           $('.retailer-logo[data-zip="'+zipcode2+'"]').show();
          }else{
           $('.retailer-logo[data-zip="'+zipcode1+'"]').show();
          }
      		
        } 
      });
    }
  }

buildRetailerZips()
});
//]]>


$(function() {
  
  
  if($('#custom-collection-template').length > 0 && !$('#custom-collection-template').hasClass('manual') ){
  
var _PageUrls = [];  
var product_per_page = 48;  
var total_products = $('#custom-collection-template').data('products');
var page_number = 1;
var collection_item = [];
var collectionStorage = 'current-page-';
var last_product = "";
var ajax_counter = 0;
var _Handles = [];
    
    function CheckItemOrder(handle, priority){

      for(var i = 0; i < collection_item.length; i++){
        var _this = $(collection_item[i]);
        if( _this.data('title') == handle){
          
          var item_priority = parseInt(_this.data('priority'));
          if(item_priority < priority){
            return false;
          }else{
            collection_item.splice(i, 1); 
            return true;
          }
        }
      }
    }

    function ProductLoop(product){
      if($(product).data('title')){
        var handle = $(product).data('title');
        var prefix = $(product).data('prefix');
        var priority = parseInt($(product).data('priority'));
        if( _Handles.indexOf(handle) == -1 ){
          _Handles.push(handle);
          collection_item.push($(product));
        }else{

          if(CheckItemOrder(handle, priority)){
            collection_item.push($(product));
          }else{
            $(product).remove();
          }

        }
      }
    }

	
    //slick options for product-item.liquid
    
    function slickOpts(prev,next){
      return {
        responsive:[
          {
            breakpoint:9999,
            settings:"unslick"
          },
          {
            breakpoint:1006,
            settings:{
              prevArrow: prev,
              nextArrow: next,
              lazyLoad: 'ondemand',
              arrows:true,
              fade:true,
              dots:false,
              slidesToShow:1,
              slidesToScroll:1,
            }
          }
        ]
      };

    }

    
    function ReBuildProducts(){

      
      $('.ProductList.ProductList--grid').empty();

      var start = (product_per_page) * (page_number-1);
      var total_products = page_number * product_per_page;
      for(var i = start; i < total_products; i++){
        $('.ProductList.ProductList--grid').append(collection_item[i]);
      }
      setTimeout(function(){
      $('.ProductItem-Slider').each(function(){
      	var product = $(this);
        var next = product.find('.next');
        var prev = product.find('.prev');
        
        var reinitSliders = product.find('.AspectRatio-slider.slick-initialized');
        if(reinitSliders  ){
          try{
          reinitSliders.slick('reinit');
          } catch(e){
          	reinitSliders.slick();
          }
        }
        
        
        
        var slider = product.find('.AspectRatio-slider:not(.slick-initialized)');
        if(slider.find('.Image--lazyLoaded').length > 0){
          slider.slick(slickOpts(prev,next))

        } else{
          slider.find('img').on('load appear lazyloaded',function(){
            $(this).addClass('Image__lazyLoaded');
            if(!slider.hasClass('slick-initialized')){
              slider.slick(slickOpts(prev,next));
            }
          })
        }
      })},300)

      }  



    function BuildPagination(){
      
      $('.Pagination__Nav.original').hide();
      var previous = page_number-1;
      var next = page_number+1;
      var total_page_number = Math.ceil(collection_item.length / product_per_page);
     
      if($('.Pagination__Nav.custom').length == 0){
        var pagination_container = $('<div class="Pagination__Nav custom">');
      }else{
        var pagination_container = $('.Pagination__Nav.custom');
        pagination_container.empty();
      }
      var loop_counter = 0;
      var elipsis = false;

      if(page_number > 1){
        var first = '<a  class="Pagination__NavItem Link Link--primary" rel="prev" data-page="' + previous +'">&larr;</a>'
        pagination_container.append(first);
      }

	   
      if(page_number+4 < total_page_number ){
        loop_counter = page_number+4;
        elipsis = true;
      }else{
        loop_counter = total_page_number;
      }
	
      for(var i = 1; i <= loop_counter; i++){


        if( i == page_number){
          var page = '<span data-page="' + i +'" class="custom-pagination Pagination__NavItem is-active">'+page_number+'</span>'
        }else{
          var page = '<a class="custom-pagination Pagination__NavItem Link--primary" data-page="' + i +'">' + i +'</a>'
        }


        pagination_container.append(page);
      }

      if(elipsis){
        var elipsis = '<span class="Pagination__NavItem ">…</span>'
          pagination_container.append(elipsis);

        var last = '<a class="custom-pagination Pagination__NavItem Link--primary" data-page="' + total_page_number +'">' + total_page_number +'</a>'
        pagination_container.append(last);
      }



      if(page_number < total_page_number){
        last = '<a class="custom-pagination Pagination__NavItem Link--primary" data-page="' + next +'">&rarr;</a>'
        pagination_container.append(last);
      }
      if(total_page_number > 1){
         pagination_container.parent().show();
      }

      $('.Pagination.Text--subdued').append(pagination_container);
      $('.collection-footer').show();
    }
  
  function LoadProducts(hasStorage, storageKey){

    for(var i = 0; i < _PageUrls.length; i++) {
      $.ajaxq('AjaxQueue', {
         type: 'GET',
         url: _PageUrls[i] + '&view=pagination',
         async: true,
         success: function(data) {
           
           
           var html = $.parseHTML( data );
           var collection = $(html).find('.ProductList').get(0);
           var new_products = $(collection).find('.product-box');
           new_products.each(function(){
             ProductLoop(this);
           });
            
           //increment ajax counter
           ajax_counter++;
           
           
           if(ajax_counter == _PageUrls.length){

             BuildCache(hasStorage, storageKey);
             
           }
           
           ReBuildProducts();
           BuildPagination();

         },
         dataType: "html",
      })

      

    }
  }
    
    function BuildCache(hasStorage, storageKey, index){
      	   

         if (hasStorage) {


           var content = [];

           for(var i = 0; i < collection_item.length ; i++){
		      collection_item[i].find('.slick-initialized').slick('unslick');
              content.push($(collection_item[i]).clone().wrap('<p>').parent().html());
            }
           
            try {
                sessionStorage.setItem(storageKey, JSON.stringify({
                    timestamp: new Date(),
                    content: content
                }));
            }
            catch (e) {
                // silently suppress, it doesn't really matter
            }
        }
    }
  

  // click custom pagination
    $(document).on('click', 'a.custom-pagination', function(e){
      if(!$(this).hasClass('active')){
        $('.custom-pagination.active').removeClass('active');
        page_number = parseInt($(this).data('page'));
        
        localStorage.setItem(collectionStorage,page_number);
        insertParam('page',page_number);
        $(this).addClass('active');
        ReBuildProducts();
        BuildPagination();
        TopFunction();

      }
    });
  
    function loadAllUrls(){
        var currentPage = getQueryVariable('page');
        var maxPageNumber = 1;
        var maxPageUrl = '';

        $('.Pagination__Nav.original .Pagination__NavItem').each(function(){
            var currentValue = parseInt($(this).data('page'));
          
          if(isNaN(currentValue)){
          	currentValue = $(this).data('page');
          }
            if(currentValue > 0 && currentValue > maxPageNumber){
                maxPageNumber = currentValue;
                maxPageUrl = $(this).attr('href');
            }
        });
        // check if sorting 
        var sorting = false;

        if( IsSorting() ){
          sorting = true;
          var sort_var = getQueryVariable('sort_by');
        }

        var urlFormat = maxPageUrl.substring(0,maxPageUrl.indexOf("=")+1);
        var j=0;
        for(var i=1;i<maxPageNumber + 1;i++){
          if(currentPage != i){
              if(sorting){
                _PageUrls[j] = urlFormat + i + "&sort_by="+sort_var;
              }else{
                _PageUrls[j] = urlFormat + i;
              }
               j++;
            }
        }

    }
  
      function TopFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    } 

    function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return 1;
    } 
    
    

    $(document).on('click', 'a.product_card', function(e){
      var parent = $(this).parents('.box').data('title');
      var hash = window.location.hash;
      if($('.pagination.custom').length != 0){
        var page = $('.pagination.custom .active a').data('page');
      }else{
        var page = 1;
      }
      var query = "?product="+parent+"&page_number="+page;

      //check if sorted

      if(IsSorting()){
        var sort_by = getQueryVariable('sort_by');
        query += "&sort_by="+sort_by;
      }



      var url = document.location.href+query;
      window.history.replaceState(null, null, query);
    });
    
    function getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    }
    
    function SetVariables(){
      var params = {};
      params = getUrlVars();  

      if(params){
        var page = params['page'];
		//get page number
        if(!isNaN(page)){
          page_number = parseInt(page);
          
        }
        //get last product
        if(params.hasOwnProperty('product')){ 
           last_product = params['product'];
           }
    }
  }
   
    
    function ClearParams(){
      var uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clean_uri);
      }
    }    
    
    
    function IsSorting(){
      var sort_by = getQueryVariable('sort_by');
      if( sort_by != 1 && sort_by != "manual"){
        return true;
      }
      
      return false;
    }
    
    function CheckCache(){
      
      var hasStorage = ("sessionStorage" in window && window.sessionStorage),
      storageKey = window.location.pathname,
      now, expiration, data = false;
      var expiration_var = 5;
      
      //add additional key if sorted
      
      if(IsSorting()){
        var sort_by = getQueryVariable('sort_by');
        storageKey += "/"+sort_by;
      }
      
      
 
      try {
          if (hasStorage) {
              data = sessionStorage.getItem(storageKey);
              if (data) {
                  // extract saved object from JSON encoded string
                  data = JSON.parse(data);
                

                  // calculate expiration time for content,
                  // to force periodic refresh after 30 minutes
                  now = new Date();
                  expiration = new Date(data.timestamp);
                  expiration.setMinutes(expiration.getMinutes() + expiration_var);

                  // ditch the content if too old
                  if (now.getTime() > expiration.getTime()) {
                      data = false;
                      sessionStorage.removeItem(storageKey);
                  }
              }
          }
      }
      catch (e) {
          data = false;
      }
      
      data = {
        data: data,
        hasStorage: hasStorage,
        storageKey: storageKey
      }
      
      return data;
      
    }
    
    
    function InitData(){
      
      var data = CheckCache();	
      
      var cache_collection = data.data;
      var hasStorage = data.hasStorage;
      var storageKey = data.storageKey;
      
  
      SetVariables();
      

		
    //DISABLING CACHING TGO
       if (cache_collection) {
          // load data from session storage
        collection_item = cache_collection['content'];
        ReBuildProducts();
        BuildPagination();

      }
      
      else { 
        
        loadAllUrls(); 
        $('.product-box').each(function(i){
          ProductLoop(this);
        });

        ReBuildProducts();
        LoadProducts(hasStorage, storageKey);

      }
       $(document).on('click','.slider-arrows',function(e){
    	e.preventDefault();
         e.stopPropagation();
        return false;
    })
   
    }

    
    InitData();
    
  }
    
});


/*CUSTOM*/
/*Variant Stock Message*/


function variantStockNotification(item){
  var val = $(item).data('notification');
  if(val === 'true'){
    if(!$('.sold-out-text').hasClass('hidden')){
      $('.sold-out-text').addClass('hidden');
    } else $('.sold-out-text').removeClass('hidden')
  }
}

function variantChangeStockNotification(v){
  if(v.inventory_quantity > 0){
  	$('.sold-out-text').addClass('hidden');
  } else {
  	$('.sold-out-text').removeClass('hidden');
  }
}